import { render } from "./HeroSectionComp.vue?vue&type=template&id=339c7309&scoped=true"
import script from "./HeroSectionComp.vue?vue&type=script&lang=js"
export * from "./HeroSectionComp.vue?vue&type=script&lang=js"

import "./HeroSectionComp.vue?vue&type=style&index=0&id=339c7309&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-339c7309"]])

export default __exports__